/**
 * School Type Constants
 * Centralized configuration for school type arrays used across the application
 */

/**
 * Primary school types
 * Used for primary school specific features and access control
 */
export const PRIMARY_SCHOOL_TYPES = [
  "jardinEnfant",
  "ecole",
];

/**
 * College school types
 * Used for college/lycee specific features and access control
 */
export const COLLEGE_SCHOOL_TYPES = [
  "college",
  "lycee",
];

/**
 * All school types
 */
export const ALL_SCHOOL_TYPES = [
  "jardinEnfant",
  "ecole",
  "college",
  "lycee",
];

/**
 * Helper function to check if a school type is a primary school
 * @param {string|Array<string>} schoolType - Single school type or array of school types
 */
export const isPrimarySchoolType = (schoolType) => {
  if (Array.isArray(schoolType)) {
    return schoolType.some(type => PRIMARY_SCHOOL_TYPES.includes(type));
  }
  return PRIMARY_SCHOOL_TYPES.includes(schoolType);
};

/**
 * Helper function to check if a school type is a college
 * @param {string|Array<string>} schoolType - Single school type or array of school types
 */
export const isCollegeSchoolType = (schoolType) => {
  if (Array.isArray(schoolType)) {
    return schoolType.some(type => COLLEGE_SCHOOL_TYPES.includes(type));
  }
  return COLLEGE_SCHOOL_TYPES.includes(schoolType);
};

/**
 * Helper function to check if a school type is college only (not primary)
 * @param {string|Array<string>} schoolType - Single school type or array of school types
 */
export const isCollegeOnlyType = (schoolType) => {
  if (Array.isArray(schoolType)) {
    return schoolType.every(type => COLLEGE_SCHOOL_TYPES.includes(type)) && 
           !schoolType.some(type => PRIMARY_SCHOOL_TYPES.includes(type));
  }
  return isCollegeSchoolType(schoolType) && !isPrimarySchoolType(schoolType);
};

/**
 * EdTrust commercial team contacts (suspension screens)
 */
export const COMMERCIAL_CONTACTS = {
  phones: ["52 588 005", "52 588 873", "52 588 822"],
  email: "commercial@edtrust.tn",
};
